import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Vault from "../../helpers/Vault";
import { login } from "../../services/login.service";
import "./google.scss";
const vault = Vault.getInstance();

export function GoogleLoginButton() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";

    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  window.handleCredentialResponse = function (response) {
    const googleJwt = response.credential;
    login(googleJwt).then((data) => {
      vault.setItem("session", data.session);
      localStorage.setItem("session", data.session);
      const search = new URLSearchParams(location.search?.slice(1));
      const r = search.get("r");
      if (r) {
        return navigate(atob(r));
      }
      navigate("/");
    });
  };

  return (
    <>
      <div
        id="g_id_onload"
        data-client_id="444087857926-pkpaspgcj9hkmunp5v992526cfs5cfv4.apps.googleusercontent.com"
        data-callback="handleCredentialResponse"
      ></div>
      <div
        className="g_id_signin"
        data-color_scheme="light"
        data-type="standard"
        data-theme="filled_black"
        data-text="continue_with"
        data-shape="pill"
      ></div>
    </>
  );
}
